import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { ICurrencySchema } from "@api/types/currencyService.type";
import {
  ICommonServiceProps,
  IGlobalMetaSchema,
} from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import URLS from "@api/constants/urls";

interface IGetAllCurrenciesService {
  data: ICurrencySchema[];
  meta: IGlobalMetaSchema;
}

interface ICurrencyServiceProps extends ICommonServiceProps {
  showActiveOnly?: boolean;
}
const useGetAllCurrencyService = ({
  page = "1",
  per_page = "15",
  showActiveOnly = true,
  enableQuery = true,
  filters = {},
  cacheKeys = [],
}: ICurrencyServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const allCurrenciesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CURRENCIES,
      debouncedQuery,
      page,
      per_page,
      showActiveOnly,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: (): Promise<IGetAllCurrenciesService> =>
      handleGlobalGetRequestQuery({
        url: URLS.CURRENCIES,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchQuery, setSearchQuery },
    services: { allCurrenciesService },
  };
};

export default useGetAllCurrencyService;
